import { render, staticRenderFns } from "./PointPaymentPopup.vue?vue&type=template&id=06faae8b&scoped=true"
import script from "./PointPaymentPopup.vue?vue&type=script&lang=js"
export * from "./PointPaymentPopup.vue?vue&type=script&lang=js"
import style0 from "./PointPaymentPopup.vue?vue&type=style&index=0&id=06faae8b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06faae8b",
  null
  
)

export default component.exports